import _ from 'lodash'

export const FETCH_GUIDES = 'FETCH_GUIDES'
export const FETCH_GUIDES_SUCCESS = 'FETCH_GUIDES_SUCCESS'

export const DELETE_GUIDE = 'DELETE_GUIDE'

export const FETCH_SPECIFIC_GUIDE = 'FETCH_SPECIFIC_GUIDE'
export const FETCH_SPECIFIC_GUIDE_SUCCESS = 'FETCH_SPECIFIC_GUIDE_SUCCESS'

export const fetchGuides = (payload) => ({
  type: FETCH_GUIDES,
  payload: _.pick(payload, ['offset', 'limit', 'search'])
})

export const fetchGuidesSuccess = (payload) => ({
  type: FETCH_GUIDES_SUCCESS,
  payload: _.pick(payload, ['guides', 'totalCount'])
})

export const deleteGuide = (payload) => ({
  type: DELETE_GUIDE,
  payload: _.pick(payload, ['guideId'])
})

export const fetchSpecificGuide = (payload) => ({
  type: FETCH_SPECIFIC_GUIDE,
  payload: _.pick(payload, ['guideId'])
})

export const fetchSpecificGuideSuccess = (payload) => ({
  type: FETCH_SPECIFIC_GUIDE_SUCCESS,
  payload: _.pick(payload, ['guide'])
})
